import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faCaretRight, faTicketAlt, faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import LinkButton from '../LinkButton/LinkButton';
import { DISCORD_LINK } from '../../constants';
import './MintCalendar.css';

const MintCalendar = () => {
  return (
    <div className='mintCalendar'>
      <label className='mintCalendar__title'>Mint Calendar</label>
      <div className='mintCalendar__box'>
        <div className='mintCalendar__item'>
          <label className='mintCalendar__status__full'>
            <FontAwesomeIcon icon={faLock}/>
            <label className='mintCalendar__status__text'>Full</label>
          </label>
          <label className='mintCalendar__subtitle'>Pre-sale closed</label>
          <label className='mintCalendar__text'>
            NFKey holders have been allocated a free RaceCar per NFKey<br/>
            NFKeys won't disappear and will grant holders with a beautiful rare asset, that will also provide advantages in and out game.
          </label>
          <LinkButton to={DISCORD_LINK}>Join discord</LinkButton>
        </div>

        <div className='mintCalendar__item'>
          <label className='mintCalendar__status__running'>
            <FontAwesomeIcon icon={faCalendarCheck}/>
            <label className='mintCalendar__status__text'>In Progress</label>
          </label>
          <label className='mintCalendar__subtitle'>Public sale is open to the everyone</label>
          <label className='mintCalendar__subtitle'>Opened December 19th - Continues until sold</label>
          <label className='mintCalendar__text'>
            Mint your RaceCar that will be playable in game! Different levels of discount will be applied depending on the amount of $RaceX in your wallet! <br/>
            Announcment to come!
          </label>
          <LinkButton to={DISCORD_LINK}>Join discord</LinkButton>
        </div>
      </div>
    </div>
  )
}

export default MintCalendar;